import { render, staticRenderFns } from "./zcGs.vue?vue&type=template&id=86f377e4&scoped=true&"
import script from "./zcGs.vue?vue&type=script&lang=js&"
export * from "./zcGs.vue?vue&type=script&lang=js&"
import style0 from "./zcGs.vue?vue&type=style&index=0&id=86f377e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f377e4",
  null
  
)

export default component.exports